
import { defineComponent, inject } from 'vue';
import { InjectionKeys } from '@/constants';
import MaterialIcon from '@/components/MaterialIcon.vue';
import Label from '@/components/form-controls/base/Label.vue';
import { useVModel } from 'vue-composable';

export default defineComponent({
  name: 'CheckboxInput',
  emits: ['update:modelValue'],
  components: {
    MaterialIcon,
    Label
  },
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      required: true
    }
  },
  setup(props) {
    const setDirty = inject(InjectionKeys.SetFormDirty);
    const checkboxValue = useVModel(props, 'modelValue');

    return {
      setDirty,
      checkboxValue
    };
  }
});
